<div #searchBarContainer class="search-bar-container" *ngIf="isBrowser(); else ssrSearch" cdkListbox [cdkListboxCompareWith]="compareSuggestion">
    <ng-container *ngTemplateOutlet="searchBar"></ng-container>
    <ng-container *ngIf="suggestions$ | async as suggestions">
        <div *ngIf="isShowSuggestion() && (suggestions?.keywords?.length || (suggestions?.products?.length && !isAuthPage()))" class="suggestion-menu dynamic-search-input-background dynamic-search-input-text-color dynamic-search-input-border-radius search-suggestion-background search-suggestion-border-radius">
            <ul tabIndex="0" [ngClass]="{ disabled: cartRepositoryService.pageMasking() }">
                @if (suggestions?.keywords?.length) {
                @for (suggestion of suggestions.keywords; track suggestion.suggestionValue) {
                <li class="keywords-list search-suggestion-text-color search-suggestion-font-size search-suggestion-font-weight" [cdkOption]="suggestion" (click)="
                searchProduct(null, {
                  suggestionKey: suggestion?.suggestionKey,
                  suggestionValue: suggestion?.suggestionValue,
                })
              " (keydown.enter)="
                searchProduct($event, {
                  suggestionKey: suggestion?.suggestionKey,
                  suggestionValue: suggestion?.suggestionValue,
                })
              " (keydown.escape)="isShowSuggestion.set(false)" [title]="suggestion.suggestionValue">
                    <img [src]="
                  headerData()?.searchSuggestionListIcon
                    ? headerData()?.searchSuggestionListIcon
                    : headerData()?.searchIcon?.searchIconSrc
                " />
                    <p TextHighlight [searchText]="searchInputControl()?.value" [content]="suggestion.suggestionValue"></p>
                </li>
                }
                }

                @if (suggestions?.products?.length && !isAuthPage()) {
                <!-- product results -->
                <section class="style-det-component-search-bar-add-to-cart" id="det-component-search-bar-add-to-cart">
                    @for (product of suggestions.products; track product._source.id) {
                    <li [cdkOption]="product" class="products-list" (keydown.enter)="navigateToProductDetailPage('/products/' + product?._source?.url_path)" (click)="navigateToProductDetailPage('/products/' + product._source?.url_path)">
                        <div class="suggested-product-card">
                            <div class="product-card-image-area">
                                @if (product._source.featured_images.length) {
                                <img class="product-card-image" [src]="product._source.featured_images[0].url" />
                                } @else {
                                <img [src]="IMAGE_URLS.noImagePlaceholder" class="product-card-image" />
                                }
                            </div>
                            <div class="product-pricing-info">
                                <!-- product display name -->
                                <h1 class="det-text-product-name" [title]="product._source.display_name || product._source.name" TextHighlight [searchText]="searchInputControl()?.value" [content]="product._source.display_name || product._source.name"></h1>
                                <!-- Selling Price -->
                                <div class="det-text-product-discounted-price-wrapper">
                                    <span class="det-text-selling-price">{{
                        product._source?.price_list?.recommended_offers?.applicable_amount | indianCurrency
                      }}</span>

                                    @if (
                                    product._source?.mrp
                                    | percentageDiscount: product._source?.price_list?.recommended_offers?.applicable_amount;
                                    as percentageDiscount
                                    ) {
                                    <span class="det-text-percentage-saving">
                                        {{ percentageDiscount }}
                                    </span>
                                    }
                                </div>
                                <!-- MRP -->
                                @if (product._source?.mrp !== product._source?.price_list?.recommended_offers?.applicable_amount) {
                                <div class="det-text-product-mrp-wrapper">
                                    <span class="det-text-product-mrp-label">MRP: </span>
                                    <span class="det-text-product-mrp"> {{ product._source?.mrp | indianCurrency }}</span>
                                </div>
                                }
                                @if (cartRepositoryService.cart(); as cart) {
                                @for (cartItem of cart?.cart_items; track cartItem.id) {
                                @if (cartItem.product.id === product._source.id) {
                                <base-search-cart-quantity-input (click)="$event.stopPropagation()" [value]="cartItem.quantity || 1" (increase$)="increaseQuantity($event, cartItem.id!)" (decrease$)="decreaseQuantity($event, cartItem.id!)" (quantityChanged$)="updateQuantity($event, cartItem.id!)">
                                </base-search-cart-quantity-input>
                                }
                                }

                                <!-- Show "Add +" button only when product is NOT in cart OR cart is empty -->
                                @if (
                                !user() || !cart || cart.cart_items.length === 0 || !isProductInCart(product._source.id, cart)
                                ) {
                                <div class="instant-cart-action-btn" (click)="searchCart(product._source); $event.stopPropagation()">
                                    Add +
                                </div>
                                }
                                } @else {
                                <!-- If cart is empty (undefined/null), show "Add +" button -->
                                <div class="instant-cart-action-btn" (click)="searchCart(product._source); $event.stopPropagation()">
                                    Add +
                                </div>
                                }
                            </div>
                        </div>
                    </li>
                    }
                </section>
                }
            </ul>
        </div>
    </ng-container>
</div>

<ng-template #ssrSearch>
    <div class="search-bar-container">
        <ng-container *ngTemplateOutlet="searchBar"></ng-container>
    </div>
</ng-template>

<ng-template #searchBar>
    <div class="search-bar">
        <input autoFocus [shouldFocus]="isFocused()" type="search" class="dynamic-search-input-background dynamic-search-input-text-color dynamic-search-input-border-color dynamic-search-input-border-radius" [formControl]="searchInputControl()!" [placeholder]="headerData()?.searchPlaceholder" (keyup)="searchProduct($event, null)" (focus)="isShowSuggestion.set(true)" (keydown.space)="$event.stopPropagation()" (click)="inputClickUpdate()" />
        <img (click)="inputClick()" [src]="headerData()?.searchIcon?.searchIconSrc" class="search-icon dynamic-search-icon-background" />
    </div>
</ng-template>